import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';
import {
  DEFAULT_MODEL,
  inferChatOpenAIManifestFromRun,
} from './ManifestChatOpenAI.utils';

export function useCustomModelEndpointModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model ?? kwargs.model_name ?? DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}

export function inferCustomModelEndpointManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun>,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  return inferChatOpenAIManifestFromRun(params, serializedModel, true);
}
